import React, { Component } from "react";
import Slider from "react-slick";
import {Card} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './slider.css';
import { hover } from "@testing-library/user-event/dist/hover";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className="className2" onClick={onClick} >
      <img className="arrow2" alt="arrow" src="images\arrow 1.svg"/>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="className" onClick={onClick} >
      <img className="arrow1" alt="arrow2" src="images\arrow 2.svg"/>
    </div>
  );
}

const Sliders = ()=>{
    const settings = {
      dots: true,
      appendDots: dots => <ul>{dots}</ul>,
    customPaging: i => (
      <div className="dot">
        
      </div>
    ),
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            appendDots: dots => <ul>{dots}</ul>,
    customPaging: i => (
      <div className="dot">
      </div>
    )
          }
        }
      ]
    };
const posts=[1,2,3,4];
const styles={
  width: '400px',
  height: '257px',
  marginRight: '90px'
}



    return (
      <div className="container">
        <div className="slider">
          <Slider {...settings}>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q4 2020</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q1 2021</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q2 2021</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q3 2021</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q4 2021</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q1 2022</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q2 2022</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q3 2022</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q4 2022</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q1 2023</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
                <div>
                  <Card className="card">
                    <Card.Body>
                      <Card.Title className="title">Q2 2023</Card.Title>
                      <Card.Text className="text">
                      - Launch of Beta version in the market<br/><br/>

                      - Organic marketing campaign<br/><br/>

                      - User feedback, learning, and <br/>
                      structuring roadmap for the first release
                      </Card.Text> 
                    </Card.Body>
                  </Card>
                </div>
          </Slider>
        </div>
      </div>
    );
}
export default Sliders;